export const userTag = 'user:';

export const resourceTag = 'resource:';
